import { useLocalStorage } from '@enroller/utils';
import { Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { AppProviders } from './AppProviders';
import { branding } from './branding';
import { activateLocale, locales } from './utils/activateLocale';

export const App = () => {
  const { defaultLocale } = branding;
  const [currentLocale] = useLocalStorage<keyof typeof locales>('currentLocale', defaultLocale);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    activateLocale(currentLocale).then(() => setLoading(false));
  }, [currentLocale]);

  if (loading) return <Typography>Loading</Typography>;

  return <AppProviders />;
};
